var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'd-none': !_vm.loading },style:(_vm.style),attrs:{"id":"loading"}},[_c('div',{attrs:{"id":"loading-center"}})])}
var staticRenderFns = []

export { render, staticRenderFns }